import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';

const Page4 = () => {
    return (
        <div className={Style.page4}>
            <div className={Style.imageWp}>
                <a href="https://www.gzxijiu.com" target="_blank" className={Style.imageWpLeft}>
                    <img src="https://x0.ifengimg.com/ucms/2025_21/B5AAFABA5AEEE475F0DFFC2A8A2FDE7B180F4299_size86_w197_h330.png" className={Style.xiImage} alt="" />
                </a>
                <div className={Style.imageWpRight}>
                    <a href="https://www.gzxijiu.com" target="_blank">
                        <img src="https://x0.ifengimg.com/ucms/2025_21/5EA181B7C9100E5D7A96DE5FEE7D1458D25D26AB_size49_w821_h99.png" className={Style.xiText} alt="" />
                    </a>
                    <div className={Style.textWp}>
                        <span className={Style.textTitle}>往季回顾</span>
                        <div className={Style.links}>
                            <a href="https://v.ifeng.com/c/special/7sRswMTLvoO" target="_blank" rel="noreferrer">
                                第一季
                                <img src="https://x0.ifengimg.com/ucms/2025_21/C13C9F0F6D693BA01944295F95EB1E3D732C42EE_size1_w21_h23.png" alt="" />
                            </a>
                            <a href="https://v.ifeng.com/c/special/85qAA0PWo4m" target="_blank" rel="noreferrer">
                                第二季
                                <img src="https://x0.ifengimg.com/ucms/2025_21/C13C9F0F6D693BA01944295F95EB1E3D732C42EE_size1_w21_h23.png" alt="" />
                            </a>
                            <a href="https://v.ifeng.com/loc/junpintan2022" target="_blank" rel="noreferrer">
                                第三季
                                <img src="https://x0.ifengimg.com/ucms/2025_21/C13C9F0F6D693BA01944295F95EB1E3D732C42EE_size1_w21_h23.png" alt="" />
                            </a>
                            <a href="https://v.ifeng.com/loc/junpintan2023" target="_blank" rel="noreferrer">
                                第四季
                                <img src="https://x0.ifengimg.com/ucms/2025_21/C13C9F0F6D693BA01944295F95EB1E3D732C42EE_size1_w21_h23.png" alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default errorBoundary(Page4);
